import React from "react";
import { connect } from "dva";
import PropTypes from 'prop-types'
import { modelUtils } from '@/utils';
import { } from '@/utils'
import { utils_tool, component_tool, framework_tool } from '@/tool'
import "./index.less";
import { Icon } from 'antd';
let { WizCollapse, WizRow, WizCol, WizButton, WizInput, WizIcon, WizCommonSteps, WizAlert, WizModal, WizForm, WizModalForm, WizCard, WizSearchBar, WizCheckbox } = component_tool
const { TextArea } = WizInput;
let { WizContainer } = framework_tool;

import {
    wizModalFormColumns,
} from './column';
const _getValue = (type, key) => {
    const values = {
        sendType: {
            '0': '站内通知',
            '1': '推送消息',
            '3': '短信通知',
            '4': '邮件通知',
            '5': '企业微信',
            '6': '智能电话',
        },
        sendTypeIcon: {
            '0': 'cloud-server',
            '1': 'mobile',
            '3': 'message',
            '4': 'mail',
            '5': 'wechat',
            '6': 'phone',
        },
    }
    return values[type][key] || ''
}

class ApplyNotice extends WizContainer {

    constructor(props) {
        super(props);
        this.state = {
            record: [],//通知信息
            currentSceneIndex: -1,//当前的场景index
            modalKey: -1,
            modalVisible: false,
            appCheck: [],//短信邮件站内的check信息（index)
            currentCommentStateName: null,//当前编辑的commentStateName
        }
    }

    static propTypes = {
        bizType: PropTypes.number,        //业务类型
        contentType: PropTypes.number,              //消息内容类型
    }
    static defaultProps = {
        bizType: null,        //业务类型
        contentType: null,              //消息内容类型
    }

    _componentDidMount() {
        if (bizType !== null || contentType !== null) {
            this.getNoticeInfoList()
        }
    }

    getNoticeInfoList = () => {
        this.doActions([
            {
                path: 'noticeTemplate/noticeInfoList',
                payload: {
                    key: 'noticeInfoList',
                    apiParams: {
                        bizType: this.props.bizType,
                        contentType: this.props.contentType,
                    }
                }
            },
        ]);
    }

    _componentDidUpdate() {
    }
    propsAndStateOnChange = {
        noticeInfoList: this._noticeInfoList.bind(this),
        value: this._linksValues.bind(this),
    };

    _linksValues(nextProps, nextState) {
        let { value } = nextProps
        if (value === undefined) {
            this.getNoticeInfoList()
            let state = {
                record: [],//通知信息
                currentSceneIndex: -1,//当前的场景index
                modalKey: -1,
                modalVisible: false,
                appCheck: [],//短信邮件站内的check信息（index)
                currentCommentStateName: null,//当前编辑的commentStateName
            }
            this.setState(state)
        }
        return true;
    }

    _noticeInfoList(nextProps, nextState) {
        let { noticeInfoList, onChange } = nextProps
        if (noticeInfoList && noticeInfoList['success']) {
            nextState['record'] = noticeInfoList['data']
            nextState['currentSceneIndex'] = noticeInfoList['data'].length ? 0 : -1
            let appCheck = noticeInfoList['data'] && noticeInfoList['data'][0] && noticeInfoList['data'][0]['sceneInfoList'].map((value, index) => value['checkIn'] ? [] : index) || []
            nextState['appCheck'] = appCheck
            onChange && onChange(noticeInfoList['data'])
            return true
        } else {
            return false
        }
    }
    _noticeOnChange(commentName, e) {
        if (commentName) {
            this.setState({
                [commentName]: e.target.value
            })
        }
    }
    _header(value, index) {
        const { appCheck, record, currentSceneIndex } = this.state
        const { onChange } = this.props
        return <WizCollapse.Panel key={currentSceneIndex + '@' + index} header={
            <WizRow>
                <WizCol span={24} style={{ textAlign: 'left' }}>
                    <WizCheckbox.Group key={currentSceneIndex + '@' + index} options={[{
                        label:
                            <>
                                <Icon type={_getValue('sendTypeIcon', value['sendType'])} />
                                {'    ' + _getValue('sendType', value['sendType'])}
                            </>
                        , value: index
                    }]}
                        value={appCheck}
                        onClick={(e) => { e.stopPropagation() }}
                        onChange={(checkedValues) => {
                            let appCheckValue = Object.assign([], appCheck)
                            if (checkedValues instanceof Array) {
                                //group修改时需要将record的值变更
                                if (checkedValues.length > 0) {
                                    appCheckValue.push(...checkedValues)
                                    record[currentSceneIndex]['sceneInfoList'][index]['checkIn'] = 0
                                    this.setState({ appCheck: appCheckValue }, () => {
                                        onChange && onChange(record)
                                    })
                                } else {
                                    appCheckValue.splice(appCheckValue.findIndex(item => item === index), 1)
                                    //如果box不勾选，则将按钮变成编辑按钮
                                    record[currentSceneIndex]['sceneInfoList'][index]['checkIn'] = 1
                                    this.setState({ appCheck: appCheckValue, [currentSceneIndex + '@Group@' + index]: 0 }, () => {
                                        onChange && onChange(record)
                                    })
                                }
                            }

                        }} />
                </WizCol>
            </WizRow>
        }
            className='panel-item'>

            <WizRow>
                {value['sendType'] == 6 ? <>
                    <WizCol span={22} style={{ textAlign: 'left' }}>
                        {this.state[currentSceneIndex + '@Group@' + index] ?
                            <WizInput ref={currentSceneIndex + '@code@' + index} key={currentSceneIndex + '@code@' + index}
                                //onFocus={this._commentOnfocus(currentSceneIndex + '@comment@' + index)}
                                value={this.state[currentSceneIndex + '@code@' + index]} placeholder="请输入语音模板编码" onChange={this._noticeOnChange.bind(this, currentSceneIndex + '@code@' + index)} />
                            :
                            <div className="apply-notice-value" >
                                <div className="apply-notice-value__title">模板编码:</div>
                                {value['code'] != '' && value['code'] !== undefined ?
                                    <div className="apply-notice-value__value">
                                        <p>{value['code']}</p>
                                    </div>
                                    : <div className="apply-notice-value__title">暂无</div>
                                }
                            </div>}
                    </WizCol></> : <></>}
                <WizCol span={22} style={{ textAlign: 'left' }}>
                    {this.state[currentSceneIndex + '@Group@' + index] ?
                        <TextArea ref={currentSceneIndex + '@comment@' + index} key={currentSceneIndex + '@comment@' + index}
                            //onFocus={this._commentOnfocus(currentSceneIndex + '@comment@' + index)}
                            value={this.state[currentSceneIndex + '@comment@' + index]} maxLength={500} rows={4} placeholder="请输入通知内容" onChange={this._noticeOnChange.bind(this, currentSceneIndex + '@comment@' + index)} />
                        :
                        <div className="apply-notice-value" >
                            <div className="apply-notice-value__title">通知内容：</div>
                            {value['content'] != '' && value['content'] !== undefined ?
                                <div className="apply-notice-value__value">
                                    <p>{value['content']}</p>
                                </div>
                                : <div className="apply-notice-value__title">暂无</div>
                            }
                        </div>
                    }
                </WizCol>

                <WizCol span={2} style={{ textAlign: 'right' }}>
                    {this.state[currentSceneIndex + '@Group@' + index] ?
                        <WizButton type="primary" onClick={() => {
                            //保存record的值
                            let comment = this.state[currentSceneIndex + '@comment@' + index]
                            let code = this.state[currentSceneIndex + '@code@' + index]
                            record[currentSceneIndex]['sceneInfoList'][index]['content'] = comment
                            record[currentSceneIndex]['sceneInfoList'][index]['code'] = code
                            this.setState({
                                [currentSceneIndex + '@Group@' + index]: 0
                            }, () => {
                                onChange && onChange(record)
                            })
                        }}>保存</WizButton>
                        :
                        <WizButton type="primary" disabled={value['sendType'] === 3 ? true : !appCheck.includes(index)} onClick={() => {
                            this.setState({
                                [currentSceneIndex + '@Group@' + index]: 1,
                                //currentCommentStateName:currentSceneIndex + '@comment@' + index,
                                [currentSceneIndex + '@comment@' + index]: value['content'],
                                [currentSceneIndex + '@code@' + index]: value['code']
                            })
                        }}>编辑</WizButton>
                    }
                </WizCol>
            </WizRow>
        </WizCollapse.Panel>
    }
    _getSceneInfoList(index) {

        const { record } = this.state
        let sceneInfoList = []
        if (record && record[index]) {
            sceneInfoList.push(...record[index]['sceneInfoList'])
        }

        return sceneInfoList;
    }
    _detail() {
        const { appCheck, currentSceneIndex, record } = this.state
        let sceneInfoList = this._getSceneInfoList(currentSceneIndex)
        let defaultActiveKey = []
        appCheck.forEach(element => {
            defaultActiveKey.push(currentSceneIndex + '@' + element)
        });
        return (
            <div>
                <WizCollapse className='audit-collapse' key={currentSceneIndex}
                    expandIconPosition='right'
                    defaultActiveKey={defaultActiveKey}
                >
                    {sceneInfoList.map((value, index) => this._header(value, index))}
                </WizCollapse>


            </div>
        )
    }
    _getModalProps = (record, visible, rows) => {

        return {
            title: record && record['sceneName'] || '',
            record: { sceneName: record && record['sceneName'] || '', sendType: record && record['sceneInfoList'].map(p => p['sendType']) || [] },
            rowKey: "id",
            showNum: false,
            selectType: "checkbox",
            isScroll: false,
            visible: visible,
            columns: wizModalFormColumns(this, record),
            modalOpts: {
                width: 600
            },
            onCancel: () => {
                this.setState({
                    //record: {},
                    modalVisible: false
                });
            },
            onSubmit: values => {
                if (!this.state.record[this.state.modalKey]) {
                    let sceneInfoListInfo = []
                    values['sendType'].forEach(element => {
                        sceneInfoListInfo.push({ content: '', sendType: element, id: null })
                    });
                    this.state.record[this.state.modalKey] = { sceneName: values['sceneName'], sceneInfoList: sceneInfoListInfo }
                } else {

                    let sceneInfoListInfo = []
                    values['sendType'].forEach(element => {
                        for (let index = 0; index < this.state.record[this.state.modalKey]['sceneInfoList'].length; index++) {
                            let xxx = this.state.record[this.state.modalKey]['sceneInfoList'][index]
                            if (xxx['sendType'] === element) {
                                sceneInfoListInfo.push(xxx)
                                return
                            }
                        }
                        sceneInfoListInfo.push({ content: '', sendType: element, id: null })
                    });
                    this.state.record[this.state.modalKey] = { sceneName: values['sceneName'], sceneInfoList: sceneInfoListInfo }
                }
                this.setState({
                    modalVisible: false
                });
            }
        };
    }
    _render() {
        const { currentSceneIndex, record, modalKey, modalVisible } = this.state

        let cardProps = {
            key: 5,
            headStyle: {
                fontSize: 14,
                color: 'rgba(24, 144, 255, 1)',
                background: '#FFFFFF',
                borderBottom: 1,
            },
            bodyStyle: {
                textAlign: 'center', verticalAlign: 'middle', padding: 1, margin: 1, //height: '67%'
            },
        };
        let tabList = []


        record.forEach((element, index) => {
            tabList.push({
                key: index,
                tab:
                    <>{element['sceneName']}  <WizButton icon="form" onClick={() => {
                        this.setState({ modalKey: index, modalVisible: true })
                    }}>修改</WizButton></>
            }
            )
        })

        tabList.push({
            key: record.length, tab:
                <WizButton icon="plus" onClick={() => {
                    record[record.length] = { sceneName: '', sceneInfoList: [] }
                    this.setState({ currentSceneIndex: 0 })
                }}>新增</WizButton>
        })
        return (
            <div>


                <WizCard key={currentSceneIndex}
                    {...cardProps}
                    tabList={tabList}
                    defaultActiveTabKey={currentSceneIndex}
                    onTabChange={key => {
                        let sceneInfoList = this._getSceneInfoList(key)
                        let appCheck = sceneInfoList.map((value, index) => value['checkIn'] ? null : index)
                        this.setState({ currentSceneIndex: key, appCheck });
                    }}
                >
                    {this._detail()}
                </WizCard>

                <WizModalForm {...this._getModalProps(currentSceneIndex >= 0 ? this.state.record[currentSceneIndex] : null, modalVisible)} />

            </div>
        )
    }

}


const mapStateToProps = (state, ownProps) => {

    const { noticeTemplate } = state;
    const noticeInfoList = modelUtils.getModelEntity(noticeTemplate, "noticeInfoList");
    // const submitAudit = modelUtils.getModelEntity(procTaskTodo, "submitAudit");

    const load = modelUtils.getLoadingState(state, ['noticeTemplate']);
    return {
        noticeInfoList,
        //   submitAudit,
        ...load
    }
};

ApplyNotice.validator = (rule, value, callback) => {
    if (value) {
        callback()
        return
    } else {
        callback('请添加关联业务')
        return
    }
    callback()
}
export default connect(mapStateToProps)(ApplyNotice)
